const baseURL = 'https://test.komerzy.com/';

export default baseURL;
